export default class InactivityManager {
  constructor(options = {}) {
    this.timeout = options.timeout || 5 * 60 * 1000 // Default: 5 minutes
    this.callback = options.callback || (() => {})
    this.events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']

    this.isActive = false
    this.timer = null

    // Bind methods to preserve context
    this.resetTimer = this.resetTimer.bind(this)
    this.handleActivity = this.handleActivity.bind(this)
  }

  addEventListeners() {
    this.events.forEach(event => {
      document.addEventListener(event, this.handleActivity, true)
    })
  }
  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
  getIsActive() {
    return this.isActive
  }
  handleActivity() {
    if (this.isActive) {
      this.resetTimer()
    }
  }
  removeEventListeners() {
    this.events.forEach(event => {
      document.removeEventListener(event, this.handleActivity, true)
    })
  }
  resetTimer() {
    this.clearTimer()
    this.timer = setTimeout(() => {
      if (this.isActive && this.callback) {
        this.callback()
      }
    }, this.timeout)
  }
  setCallback(newCallback) {
    this.callback = newCallback
  }
  setTimeout(newTimeout) {
    this.timeout = newTimeout
    if (this.isActive) {
      this.resetTimer()
    }
  }
  start() {
    if (this.isActive) return

    this.isActive = true
    this.addEventListeners()
    this.resetTimer()
  }
  stop() {
    if (!this.isActive) return

    this.isActive = false
    this.removeEventListeners()
    this.clearTimer()
  }
}
